import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import StatusLabel from 'components/consumer/StatusLabel';
import IconPlay2 from 'components/icons/iconPlay2';

const LiveVideoPlayingBanner = ({ category, title, slug = '' }) => (
  <Link
    className="bg-white bottom-0 shadow-[0-4px_34px_rgba(0,0,0,.08)] flex px-5 py-4 sticky z-[1] hover:cursor-pointer md:flex-row-reverse md:justify-end md:px-[3.333vw] md:py-[1.2rem]"
    to={`/videos/${slug}`}
  >
    <div className="max-[767px]:flex-1">
      {!!title && (
        <div className="text-lg font-bold text-gray md:text-2xl md:font-bold">
          {title}
        </div>
      )}

      {!!category && (
        <div className="text-xs text-gray-light1 md:text-sm md:font-bold md:text-gray-light2">
          {category}
        </div>
      )}
    </div>

    <div className="items-center flex justify-center px-5 py-0 max-[767px]:pr-0 md:pl-0 animate-full-pulse">
      <StatusLabel color="red-dark">
        <div className="items-center flex [&_>_*:first-child]:mr-[5px]">
          <span>STREAMING NOW</span>
          <IconPlay2 height={9} width={6} />
        </div>
      </StatusLabel>
    </div>
  </Link>
);

LiveVideoPlayingBanner.propTypes = {
  category: PropTypes.string,
  title: PropTypes.string,
  slug: PropTypes.string,
};

export default LiveVideoPlayingBanner;
